import { useQuery } from "@tanstack/react-query";
import { PageResponse } from "../models/response";
import HttpClient from "../utils/network";
import { OnSiteApi } from "../apis/onsite";
import { CacheKey } from "../models/cacheKey";
import { CheckInsList } from "../models/checkInsList";
import { CheckInSummaryDto } from "../models/checkInSummary";
import { AxiosError } from "axios";
import { AdminUser } from "../models/adminUser";

export function useCheckIns(
  artistId?: number,
  adminUser?: AdminUser,
  page: number = 0,
) {
  const {
    data: checkInList,
    isLoading,
    isError,
    error,
  } = useQuery<CheckInsList, AxiosError>({
    queryKey: [CacheKey.getCheckIns, artistId, page],
    queryFn: async () => {
      console.log("artistId", artistId, "page", page, "adminUser", adminUser);
      const eventId = adminUser?.eventId;
      const response = new PageResponse<CheckInSummaryDto>(
        await HttpClient.request(OnSiteApi.events(artistId, eventId, page)),
      );
      return new CheckInsList(response);
    },
    enabled: artistId !== undefined && adminUser !== undefined,
  });

  return { checkInList: checkInList, isLoading, isError, error };
}
